import React, { useCallback, useState } from 'react'
import PropTypes from 'prop-types'
import { Modal } from 'react-bootstrap'
import { useDispatch } from 'react-redux'
import { toastr } from 'react-redux-toastr'
import { useTranslation } from 'react-i18next'

import ModalDelete from './ModalDelete'
import { vinValidation, imeiValidation } from '../../helpers/helperVehicle'
import CustomButton from '../../CustomButton'
import { deviceReplace } from "../../../../../shared/api/action/DeviceActions";

const ModalDeviceReplace = (props) => {
	const dispatch = useDispatch();
	const { onHide, device, updateDeviceData } = props;
	const { t } = useTranslation('translation', { keyPrefix: 'manageVehiclesPage.editAssetContainer.modalDeviceReplace' });

	const [replace_type, setReplace_type] = useState('camera');
	const [imei, setImei] = useState('');
	const [vin, setVin] = useState('');
	const [tag_number, setTag_number] = useState('');
	const [vehicle_name, setVehicle_name] = useState('');
	const [errMessage, setErrMessage] = useState({
		err_imei: '',
		err_vin: '',
		err_tag_number: '',
		err_vehicle_name: '',
	});
	const [showConfirmModal, setShowConfirmModal] = useState(false);
	const [upd, setUpd] = useState(false);

	const toggleLoader = useCallback((show) => {
		dispatch({ type: 'TOGGLE_LOADER', payload: show });
	}, [dispatch]);

	const onChangeField = (e) => {
		const { target } = e
		const { name } = target
		const value = target.type === 'checkbox' ? target.checked : target.value

		if (name === "replace_type") setReplace_type(value);
		if (name === "imei") {
			setImei(value);
			errMessage.err_imei && checkForm({ imei: value });
		}
		if (name === "vin") {
			setVin(value);
			errMessage.err_vin && checkForm({ vin: value });
		}
		if (name === "tag_number") setTag_number(value);
		if (name === "vehicle_name") setVehicle_name(value);
	}

	const checkForm = (params) => {
		let error = false
		let errMessageUpdate = errMessage;
		for (let i in params) {
			if (!params[i]) {
				error = true
				errMessageUpdate['err_' + i] = t('enterValue')
			}
			else if (errMessageUpdate['err_' + i]) {
				errMessageUpdate['err_' + i] = '';
			}
		}

		if (params.imei !== undefined && !errMessageUpdate.err_imei) {
			if (!imeiValidation(imei)) {
				error = true
				errMessageUpdate.err_imei = t('err_imei')
			}

			if (!(/^(XC4RECO|DV401)/.test(imei) || /^\D*(?:\d\D*){15}$/.test(imei))) {
				error = true
				errMessageUpdate.err_imei = t('err_imei_length')
			}
		}

		if (params.vin !== undefined && !errMessageUpdate.err_vin) {
			if (params.vin && !vinValidation(params.vin)) {
				error = true
				errMessageUpdate.err_vin = t('err_vin')
			}
		}

		setErrMessage(errMessageUpdate);
		return error
	}

	const onReplaceClick = () => {
		const params = {
			replace_type,
		}
		if (replace_type === 'camera') {
			params.imei = imei
		}
		else {
			params.vin = vin
			params.tag_number = tag_number
			params.vehicle_name = vehicle_name
		}

		if (!checkForm(params)) {
			setShowConfirmModal(true)
		}
		setUpd(!upd);
	}

	const onConfirmReplaceClick = () => {
		const params = {
			device_id: device.device_id,
			replace_type,
		}
		if (replace_type === 'camera') {
			params.serial_number = imei
		}
		else {
			params.vin = vin
			params.tag_number = tag_number
			params.vehicle_name = vehicle_name
		}

		toggleLoader(true);
		deviceReplace(params)
			.then((res, err) => {
				setShowConfirmModal(false)
				updateDeviceData()
				toggleLoader(false);
				toastr.success('', t('updatedVehicle'))
				onHide()
			})
			.catch((error) => {
				console.log('onUploadVehicles error: ', error.response, error)
				toggleLoader(false);
				setShowConfirmModal(false)
				const { status, data } = error.response
				if (status >= 400 && status < 500) {
					toastr.error(data.response.error);
				} else {
					toastr.error(t('unableUploadVehicles'));
				}
			})
	}

	const { err_imei, err_vin, err_tag_number, err_vehicle_name } = errMessage;

	return (
		<Modal
			show
			onHide={onHide}
			aria-labelledby="contained-modal-title-lg"
			className="modal-lg-size"
		>
			<Modal.Header closeButton>
				<Modal.Title>
					{`${t('replaceFor')} ${device.vehicle_name || device.device_id}`}
				</Modal.Title>
			</Modal.Header>
			<Modal.Body>
				<div>
					<p className="modal-text">{t('selectType')}</p>
					<div>
						<div className="form-check" style={{ paddingLeft: '0px' }}>
							<input
								type="radio"
								id="radios1"
								key="Same Vehicle, Different Camera"
								name="replace_type"
								value="camera"
								checked={replace_type === "camera"}
								onChange={onChangeField}
								style={{ marginRight: '5px' }}
							/>
							<label className="form-check-label" for="radios1">
								{t('sameVehicle')}
							</label>
						</div>
						<div className="form-check" style={{ paddingLeft: '0px' }}>
							<input
								type="radio"
								id="radios2"
								key="Same Camera, Different Vehicle"
								name="replace_type"
								value="vehicle"
								checked={replace_type === 'vehicle'}
								onChange={onChangeField}
								style={{ marginRight: '5px' }}
							/>
							<label className="form-check-label" for="radios2">
								{t('sameCamera')}
							</label>
						</div>
					</div>

					<hr />

					{replace_type === "camera"
						? (
							<div className={`${err_imei && 'has-error'}`}>
								<label>{t('enterIMEI')}</label>
								<input
									type="text"
									name="imei"
									className="vehicle-search"
									placeholder={t('placeholderIMEI')}
									value={imei || ''}
									onChange={onChangeField}
								/>
								{err_imei && <span className="help-block">{err_imei}</span>}
							</div>
						) : (
							<div>
								<div className={`form-group${err_vin && ' has-error'}`}>
									<label>{t('enterVIN')}</label>
									<input
										type="text"
										name="vin"
										className="vehicle-search"
										placeholder={t('placeholderVIN')}
										value={vin || ''}
										onChange={onChangeField}
									/>
									{err_vin && <span className="help-block">{err_vin}</span>}
								</div>
								<div className={`form-group${err_tag_number && ' has-error'}`}>
									<label>{t('enterTAG/PLATE')}</label>
									<input
										type="text"
										name="tag_number"
										className="vehicle-search"
										placeholder={t('placeholderTag/Plate')}
										value={tag_number || ''}
										onChange={onChangeField}
									/>
									{err_tag_number && <span className="help-block">{err_tag_number}</span>}
								</div>
								<div className={`${err_vehicle_name && 'has-error'}`}>
									<label>{t('enterVehicleName')}</label>
									<input
										type="text"
										name="vehicle_name"
										className="vehicle-search"
										placeholder={t('placeholderName')}
										value={vehicle_name || ''}
										onChange={onChangeField}
									/>
									{err_vehicle_name && <span className="help-block">{err_vehicle_name}</span>}
								</div>
							</div>
						)}
				</div>
			</Modal.Body>
			<Modal.Footer className="default-modal-footer modal-footer">
				<CustomButton
					variant="primary"
					onClick={onReplaceClick}
				>
					{t('btnReplace')}
				</CustomButton>
			</Modal.Footer>

			{showConfirmModal
				&& (
					<ModalDelete
						title={t('titleModalDelete')}
						content={`${replace_type === 'camera' ? t('contentCamera') : t('content')}`}
						deleteBtnName="Apply"
						backdropClassName="upper"
						showClose
						closeModal={() => setShowConfirmModal(false)}
						deleteModal={onConfirmReplaceClick}
					/>
				)}
		</Modal>
	);
}

ModalDeviceReplace.propTypes = {
	device: PropTypes.objectOf(PropTypes.any).isRequired,
	updateDeviceData: PropTypes.func.isRequired,
	onHide: PropTypes.func.isRequired
}

export default ModalDeviceReplace;
